import React, { useEffect, useState, useRef } from "react";
import "echarts-gl";
import * as echarts from 'echarts';
import PageHeader from "../../components/PageHeader.js";
import {getLastSession,getLastUser,getDashboardInfo,setDashboardInfo,getCurrentDeviceSerial,setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData, resetDevice } from '../../RestUtil.js';
import { chartOption3, chartOption4 } from "../../Data/DemographicData.js";
import SwitchBordCard from "../../components/SwitchBordCard.js";

export default function Controls(props) {

  const [sessionInfo, setSessionInfo] = useState(null);    
  const [dashData1, setDashData1] = useState(null);    
  const [buttonsIndoor, setButtonsIndoor] = useState([{title: "BRAKE STATUS",switch: false,}]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [deviceSerial, setDeviceSerial] = useState("");
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);

  useEffect(() => {
    setSessionInfo( getLastSession() );
    var profileData = getLastUser();
    if (profileData != null) {
        setDeviceSerial(profileData.deviceSerial);
    }
    var dashData2 = getDashboardInfo();
    console.log("BE Data from MRStatus", dashData2);
    setDashData1( dashData2 );
  }, []);

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
  }

  useEffect(() => {
    if (dashData1 == null) return;
    var temp1 = [...buttonsIndoor];
    temp1[0].switch = (dashData1.brakeStatus === "OPEN");
    console.log("Brake Status from BE",dashData1.brakeStatus);
    setButtonsIndoor(temp1);
  }, [dashData1])

  function handleResetButton(isTrip) {
    console.log("handleResetButton for deviceSerial",deviceSerial);
    var sessionData = getLastSession();
    console.log("Last Session",sessionData);
    resetDevice(sessionData.id,deviceSerial,isTrip).then(resp => {
      console.log("resetDevice resp",resp);
      if (isTrip)
        alert("device trip done");
      else
        alert("device reset done"); 
    })
    .catch(err2 => {
      console.log("handleResetButton failed",err2);          
    });

  }

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            {dashData1 && 
            <PageHeader
              HeaderText="Tabs"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "Controls", navigate: "" },
              ]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
              />
            }
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">
                <div className="card">
                  <div className="header" style={{textAlign:"center"}}>
                    <h2>CONTROLS</h2>
                    <div className="body">
                      <ul className="list-unstyled basic-list ng-star-inserted">
                        <li key={1} className={"ng-star-inserted"}>
                          <button className={`btn btn-outline-success`} onClick={() => handleResetButton(true)} type="button">TRIP L1,L2,L3</button>
                        </li>
                        <li key={2} className={"ng-star-inserted"}>
                          <button className={`btn btn-outline-danger`} onClick={() => handleResetButton(false)} type="button">RESET REMS</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
